type NavigatorWithBrave = Navigator & {
  brave?: unknown;
  userAgentData?: {
    brands: Array<{ brand: string; version: string }>;
  };
};

const CHROMIUM_FORK_UA_PATTERN = /\b(Edg|OPR|Opera|SamsungBrowser|UCBrowser|YaBrowser|Vivaldi)\//;
const GOOGLE_CHROME_UA_PATTERN = /\b(Chrome|CriOS)\//;

const isGoogleChromeFromBrands = (brands: string[]): boolean | null => {
  if (brands.length === 0) return null;

  if (brands.includes('Brave')) {
    return true;
  }

  if (brands.some((brand) => brand === 'Microsoft Edge' || brand.includes('Opera'))) {
    return false;
  }

  if (brands.includes('Google Chrome')) {
    return true;
  }

  if (brands.includes('Chromium')) {
    return false;
  }

  return null;
};

const isGoogleChromeFromUserAgent = (userAgent: string): boolean => {
  if (!GOOGLE_CHROME_UA_PATTERN.test(userAgent)) {
    return false;
  }

  if (CHROMIUM_FORK_UA_PATTERN.test(userAgent)) {
    return false;
  }

  if (/\bChromium\//.test(userAgent)) {
    return false;
  }

  if (/\b(FxiOS|EdgiOS)\//.test(userAgent)) {
    return false;
  }

  return true;
};

export const isGoogleChromeBrowser = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const nav = navigator as NavigatorWithBrave;

  if ('brave' in nav) {
    return true;
  }

  const brands = nav.userAgentData?.brands.map((entry) => entry.brand) ?? [];
  const brandResult = isGoogleChromeFromBrands(brands);
  if (brandResult !== null) {
    return brandResult;
  }

  return isGoogleChromeFromUserAgent(navigator.userAgent);
};
